/**
 * Media edit — edit an existing image (an upload OR one we generated) from anywhere: the media lightbox, the
 * library, later the Studio. `describe` = an instruction edit over the whole image ("make the sky a sunset");
 * `area` = a masked generative fill (Slice B). Charge-on-success; the result is a NEW owner-scoped image path.
 */
import { callFunction } from '../utils/apiClient';

export type EditMode = 'describe' | 'area';

export interface EditImageResult {
  path?: string;          // the new edited image's storage path (resolve to a URL to display)
  kind?: string;          // 'image'
  capability?: string;    // the billed capability (never the model name)
  needsTopUp?: boolean;   // wallet can't cover the edit → show the top-up card
  storageFull?: boolean;  // storage quota is full -> prompt an upgrade
  providerDown?: boolean; // generation temporarily unavailable → friendly retry
}

/**
 * Edit `sourcePath` per the plain-English `prompt`. `mode` defaults to a whole-image instruction edit;
 * `mode:'area'` regenerates only the region marked by `maskPath` (a same-dimension B/W PNG the client paints).
 */
export const editImage = (input: { sourcePath: string; prompt: string; mode?: EditMode; maskPath?: string; conversationId?: string | null }) =>
  callFunction<EditImageResult>('editImage', {
    sourcePath: input.sourcePath,
    prompt: input.prompt,
    mode: input.mode || 'describe',
    maskPath: input.maskPath || undefined,
    conversationId: input.conversationId || undefined,
  });
